import React, {
  memo, useCallback, useEffect, useState, useMemo, useContext,
} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import LanguageSelect from '../LanguageSelect';
import HeaderNavItem from './HeaderNavItem';
import PayStatus from './PayStatus/PayStatus';
import HeaderCart from './HeaderCart/HeaderCart';
import {ROUTES, buildRoute} from '../../configs/routes';
import URL_MAP from '../../constants/urls';
import {mediaSizes} from '../../configs/media';
import HeaderBurger from './HeaderBurger';
import HeaderInfoBtn from './HeaderInfo/HeaderInfoBtn';
import {LanguageContext} from '../../context/LanguageContext';
import {t} from '../../services/i18nHandler';

import './Header.less';

function Header({
  pathname, loggedIn, hideSidebar, user,
}) {
  const language = useContext(LanguageContext);

  const [windowWidth, changeWindowWidth] = useState(window.innerWidth);

  const onWindowResize = useCallback(() => {
    changeWindowWidth(window.innerWidth);
  }, []);

  const isActive = useMemo(() => (route = '') => {
    const urlArr = pathname.split('/');
    const currentPath = urlArr[1];
    return currentPath.includes(route);
  }, [pathname]);

  useEffect(() => {
    window.addEventListener('resize', onWindowResize);
    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, []);

  return (
    <header className={`header sticky ${hideSidebar ? 'header-full' : ''}`}>
      <div className="header-inner">
        <div className="header-burger-wrap">
          <HeaderBurger hideSidebar={hideSidebar} isDesktop={windowWidth > mediaSizes.xl} />
        </div>
        {windowWidth > mediaSizes.xl && (
          <>
            <nav className="top-nav">
              <ul className="top-nav_list">
                <HeaderNavItem
                  route={ROUTES.HOW_IT_WORK.route}
                  text={t('nav.howItWork')}
                  isActive={isActive(URL_MAP.HOW_IT_WORK)}
                />
                <HeaderNavItem
                  route={ROUTES.ABOUT_COMPANY.route}
                  text={t('nav.aboutCompany')}
                  isActive={isActive(URL_MAP.ABOUT_COMPANY)}
                />
                <HeaderNavItem
                  route={buildRoute(URL_MAP.PLANS)}
                  text={t('nav.services')}
                  isActive={isActive(URL_MAP.PLANS)}
                />
                <HeaderNavItem
                  route={buildRoute(URL_MAP.YOU_CANDIDATE)}
                  text={t('nav.forJobSeekers')}
                  isActive={isActive(URL_MAP.YOU_CANDIDATE)}
                />
                <HeaderNavItem
                  route={buildRoute(URL_MAP.YOU_EMPLOYER)}
                  text={t('nav.forEmployers')}
                  isActive={isActive(URL_MAP.YOU_EMPLOYER)}
                />
                <HeaderNavItem
                  route={buildRoute(URL_MAP.YOU_AGENCY)}
                  text={t('nav.forAgency')}
                  isActive={isActive(URL_MAP.YOU_AGENCY)}
                />
                <HeaderNavItem
                  route={ROUTES.NEWS.route}
                  text={t('nav.news')}
                  isActive={isActive(URL_MAP.NEWS)}
                />
                {loggedIn && (
                  <HeaderNavItem
                    route={buildRoute(URL_MAP.PROFILE_SETTINGS)}
                    text={t('nav.myAccount')}
                    isActive={isActive(URL_MAP.PROFILE_SETTINGS)}
                  />
                )}
              </ul>
            </nav>
            <div className="right-panel-wrap">
              <div className="right-panel">
                {loggedIn && (<HeaderCart />)}
                {loggedIn && (<PayStatus user={user} language={language} />)}
                <LanguageSelect />
              </div>
            </div>
          </>
        )}
        {windowWidth <= mediaSizes.xl && (
          <>
            <Link
              to={ROUTES.ROOT.route}
              className={`header_mob-logo ${language}`}
            />
            <HeaderInfoBtn />
          </>
        )}
      </div>
    </header>
  );
}

Header.defaultProps = {
  pathname: '',
  user: {},
  loggedIn: false,
  hideSidebar: false,
};

Header.propTypes = {
  pathname: PropTypes.string,
  user: PropTypes.shape({}),
  loggedIn: PropTypes.bool,
  hideSidebar: PropTypes.bool,
};

function mapStateToProps({
  router, rPages, rSession, rUser,
}) {
  return {
    loggedIn: rSession.LOGGED_IN,
    hideSidebar: rPages.hideSidebar,
    pathname: router.location.pathname,
    user: rUser,
  };
}

export default connect(mapStateToProps, null)(memo(Header));
